<p-table *ngIf="errorLogs" #dt [value]="errorLogs.results" dataKey="Id" [paginator]="true" [filterDelay]="0"
  [lazy]="true" (onLazyLoad)="lazyLoad($event)" [totalRecords]="errorLogs.totalCount"
  [sortField]="errorLogs.originalRequest.sortField" [sortOrder]="errorLogs.originalRequest.sortOrder"
  [rows]="errorLogs.originalRequest.pageSize">
  <ng-template pTemplate="header">
    <tr>
      <th pSortableColumn="id" class="width40" scope="col">Id <p-sortIcon field="id"></p-sortIcon>
      </th>
      <th pSortableColumn="level" class="width40" scope="col">Level<p-sortIcon field="level"></p-sortIcon>
      </th>
      <th pSortableColumn="timeStamp" class="width80" scope="col">Data <p-sortIcon field="timeStamp"></p-sortIcon>
      </th>
      <th pSortableColumn="message" class="width250" scope="col">Message</th>
      <th class="width80" scope="col">Properties</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-errorLogs>
    <tr class="p-selectable-row">
      <td>
        {{errorLogs.id}}
      </td>
      <td>
        {{errorLogs.level}}
      </td>
      <td>
        {{errorLogs.timeStamp | date:'dd/MM/yyyy HH:mm:ss'}}
      </td>
      <td>
        {{errorLogs.message | excerpt:90}}&nbsp;
        <app-message-dialog *ngIf="errorLogs.message.length>90"
          [message]="errorLogs.message"></app-message-dialog>&nbsp;
        <app-message-dialog *ngIf="errorLogs.exception?.length > 0" [message]="errorLogs.exception"
          [label]="'Vedi eccezione'"></app-message-dialog>
      </td>

      <td>
        <app-property-dialog [properties]="errorLogs.properties"></app-property-dialog>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="5" style="text-align:left">Nessun log disponibile</td>
    </tr>
  </ng-template>
</p-table>